import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    getCameraPresetAnglesList: [],
    createCameraPresetStatus: false,
    deleteCameraPresetStatus: false,
    addToPresetsConflict: null,
    addToPresetsLoading: false,
    getSavedCameraPresetAnglesList: [],
    selectedCameraRPList: [],
  }

const cameraAngle = createSlice({
  name: 'cameraAngle',
  initialState,
  reducers: {
    resetState: () => {
        return initialState;
    },
    setCameraPresetAnglesList: (state, { payload }) => {
      state.getCameraPresetAnglesList = payload;
    },
    setSavedCameraPresetAnglesList: (state, { payload }) => {
      state.getSavedCameraPresetAnglesList = payload;
    },
    updateSavedCameraPresetAnglesList: (state, { payload }) => {
      state.getSavedCameraPresetAnglesList = [payload, ...state.getSavedCameraPresetAnglesList];
    },
    addCameraPresetAngleList: (state, { payload }) => {
      state.getCameraPresetAnglesList.push(...payload);
    },
    setCreateCameraPresetStatus: (state, { payload }) => {
      state.createCameraPresetStatus = payload;
    },
    setDeleteCameraPresetStatus: (state, { payload }) => {
      state.deleteCameraPresetStatus = payload;
    },
    setSelectedCameraRPList: (state, { payload }) => {
      state.deleteCameraPresetStatus = payload;
    },
    setAddToPresetsLoading: (state, { payload }) => {
      state.addToPresetsLoading = payload;
    },
    addToPresetsSuccess: (state, { payload }) => {
      state.getCameraPresetAnglesList = [payload, ...state.getCameraPresetAnglesList];
    },
    setAddToPresetsConflict: (state, { payload }) => {
      state.addToPresetsConflict = payload;
    },
  },
});

export const {
  setSavedCameraPresetAnglesList,
  updateSavedCameraPresetAnglesList,
  getCameraPresetAnglesList,
  setCameraPresetAnglesList,
  addCameraPresetAngleList,
  createCameraPresetStatus,
  setCreateCameraPresetStatus,
  deleteCameraPresetStatus,
  setDeleteCameraPresetStatus,
  selectedCameraRPList,
  setSelectedCameraRPList,
  setAddToPresetsLoading,
  addToPresetsSuccess,
  setAddToPresetsConflict,
} = cameraAngle.actions;
export const cameraAngleActions = cameraAngle.actions;
export const cameraAngleSelector = (state) => state.cameraAngle;
export const cameraAngleReducer = cameraAngle.reducer;
export default cameraAngleReducer;

export const selectSavedCameraPresetAnglesList = (state) => state.cameraAngle.getSavedCameraPresetAnglesList;
export const selectCameraPresetAnglesList = (state) => state.cameraAngle.getCameraPresetAnglesList;
export const selectCameraPresetAnglesNameList = (state) =>
  state.cameraAngle.getCameraPresetAnglesList.map((c) => c.cameraName);
export const selectAddToPresetsLoading = (state) => state.cameraAngle.addToPresetsLoading;
export const selectAddToPresetsConflict = (state) => state.cameraAngle.addToPresetsConflict;
export const selectAddToPresetConflictCamera = (state) => {
  const id = state.cameraAngle.addToPresetsConflict;
  if (!id) return null;

  return state.projectCameraAngle.getProjectCameraAnglesList.find((c) => c.id === id);
};
